import { render, staticRenderFns } from "./d-book-user-reviews-overall.vue?vue&type=template&id=7c53e244&scoped=true&"
import script from "./d-book-user-reviews-overall.vue?vue&type=script&lang=js&"
export * from "./d-book-user-reviews-overall.vue?vue&type=script&lang=js&"
import style0 from "./d-book-user-reviews-overall.vue?vue&type=style&index=0&id=7c53e244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53e244",
  null
  
)

export default component.exports